import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import myResLogo from '../images/my-res-logo.webp'
import './Navbar.css'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DeleteIcon from '@material-ui/icons/Delete';
import { clearAllSnacks } from '../redux/snacks/snacksActions'
import { clearAllFood } from '../redux/food/foodActions'
import { clearAllDrinks } from '../redux/drinks/drinksActions'
import { useLogout } from '../hooks/useLogout'
import { useAuthContext } from '../hooks/useAuthContext'


const Navbar = () => {
    const {user} = useAuthContext()
    const navigate = useNavigate()
    // const { name, email } = user
    const dispatch = useDispatch()
    const burgers = useSelector(state => state.snacks.burgers)
    const burgerPrice = useSelector(state => state.snacks.burgerPrice)
    const fries = useSelector(state => state.snacks.fries)
    const friesPrice = useSelector(state => state.snacks.friesPrice)
    const wraps = useSelector(state => state.snacks.wraps)
    const wrapsPrice = useSelector(state => state.snacks.wrapsPrice)
    const pizzas = useSelector(state => state.snacks.pizzas)
    const pizzasPrice = useSelector(state => state.snacks.pizzasPrice)
    const snackItems = useSelector(state => state.snacks.snackItems)

    const biryani = useSelector(state => state.food.biryani)
    const biryaniPrice = useSelector(state => state.food.biryaniPrice)
    const friedRice = useSelector(state => state.food.friedRice)
    const friedRicePrice = useSelector(state => state.food.friedRicePrice)
    const vegBiryani = useSelector(state => state.food.vegBiryani)
    const vegBiryaniPrice = useSelector(state => state.food.vegBiryaniPrice)
    const southMeals = useSelector(state => state.food.southMeals)
    const southMealsPrice = useSelector(state => state.food.southMealsPrice)
    const northMeals = useSelector(state => state.food.northMeals)
    const northMealsPrice = useSelector(state => state.food.northMealsPrice)
    const tandooriChicken = useSelector(state => state.food.tandooriChicken)
    const tandooriChickenPrice = useSelector(state => state.food.tandooriChickenPrice)
    const grillChicken = useSelector(state => state.food.grillChicken)
    const grillChickenPrice = useSelector(state => state.food.grillChickenPrice)
    
    const mango = useSelector(state => state.drinks.mango)
    const mangoPrice = useSelector(state => state.drinks.mangoPrice)
    const coldCoffee = useSelector(state => state.drinks.coldCoffee)
    const coldCoffeePrice = useSelector(state => state.drinks.coldCoffeePrice)
    const coffee = useSelector(state => state.drinks.coffee)
    const coffeePrice = useSelector(state => state.drinks.coffeePrice)
    const pepsi = useSelector(state => state.drinks.pepsi)
    const pepsiPrice = useSelector(state => state.drinks.pepsiPrice)

    const [items, setItems] =  useState(0)
    const [price, setPrice] =  useState(0)
    const [isOpen, setIsOpen] = useState(false)
    const handleClick = () => {
        setIsOpen(!isOpen)
    }

    const handleErase = () => {
        setItems(0)
        setPrice(0)
        dispatch(clearAllSnacks())
        dispatch(clearAllFood())
        dispatch(clearAllDrinks())
    }

    const {logout} = useLogout()
    const handleLogout = () => {
        logout()
        navigate('/')
    }

    useEffect(() => {
        setItems(snackItems + biryani + friedRice + vegBiryani + southMeals + northMeals + tandooriChicken + grillChicken + mango + coldCoffee + coffee + pepsi)
        setPrice(burgerPrice + friesPrice + wrapsPrice + pizzasPrice + biryaniPrice + friedRicePrice + vegBiryaniPrice + southMealsPrice + northMealsPrice + tandooriChickenPrice + grillChickenPrice + mangoPrice + coldCoffeePrice + coffeePrice + pepsiPrice)
    },[burgers,fries,wraps,pizzas,burgerPrice,friesPrice,wrapsPrice,pizzasPrice, biryani, friedRice, vegBiryani, southMeals, northMeals, tandooriChicken, grillChicken, mango, coldCoffee, coffee, pepsi])
  return (
    <nav className='navbar'>
        <Link to={'/'} ><img src={myResLogo} alt="my Res Logo" className='navbar__myLogo'/></Link>
        <ul className='navbar__items'>
            <li className='navbar__item'><Link to={'/about'} className='listItem'>About</Link></li>
            <li className='navbar__item'><Link to={'/contact'} className='listItem'>Contact</Link></li>
            {user && (  
            <>
                <li className='navbar__item'><Link to={'/profile'} className='listItem userName'>{user.name}</Link></li>
                <li className='navbar__item'><button onClick={handleLogout} className='listItem listButton'>LogOut</button></li>
            </>
            )} 
            { !user && (
                <>
            <li className='navbar__item'><Link to={'/login'} className='listItem'>Login</Link></li>
            <li className='navbar__item'><Link to={'/signup'} className='listItem'>Sign Up</Link></li>
            </>
            ) }
        </ul>

        <ul className='navbar__itemsMob'>
            <li><Link to={'/about'} className='mobItem'>About</Link></li>
            <button className='mob__btn' onClick={handleClick}>&#8609;</button>
            { isOpen && <div className="dropdown">
                <li><Link to={'/contact'} className='mobItem'>Contact</Link></li>
                {user && (
                    <>
                        <li><Link to={'/profile'} className='mobItem mobName'>{user.name.split(' ').join('')}</Link></li>
                        <li><button onClick={handleLogout} className='mobItem mobItemButton'>LogOut</button></li>
                    </>
                )}
                {!user && (
                    <>
                        <li><Link to={'/login'} className='mobItem'>Login</Link></li>
                        <li><Link to={'/signup'} className='mobItem'>SignUp</Link></li>
                    </> 
                )}
            </div>}
        </ul>
        <div className="cart">
            <ShoppingCartIcon />
            <p>Items {items}</p>
            <p>&#8377; {price}</p>
            <button onClick={handleErase}><DeleteIcon /></button>
        </div>
    </nav>
  )
}

export default Navbar